import { render, staticRenderFns } from "./management-template-view.vue?vue&type=template&id=2997311d"
import script from "./management-template-view.vue?vue&type=script&lang=js"
export * from "./management-template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports